import ls from "local-storage";
import * as CONFIG from "../Components/_config";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { handleErrorResponse } from '../helper';

export const getCustomCategories = async () => {
  try {
    const guid = ls.get("selectedbrand") ? ls.get("selectedbrand")[0].guid : "";
    var data = "";
    var config = {
      method: "get",
      url: CONFIG.API_URL + `brand/customcategory/${guid}`,
      headers: CONFIG.config_head.headers,
      data: data
    };
  
    const response = await axios(config)
    return response.data.Message;
  } catch (error) {
    handleErrorResponse(error);
    if (error.response.status === 400) {
      toast.error(error.response.data.Message);
      return error.response;
    } else {
      toast.error(error.response.data.Message);
    }
  }    
};

export const getAllCategories = async () => {
  try {
    const guid = ls.get("selectedbrand") ? ls.get("selectedbrand")[0].guid : "";
    var data = "";
    var config = {
      method: "get",
      url: CONFIG.API_URL + `brand/allcategory/${guid}`,
      headers: CONFIG.config_head.headers,
      data: data
    };
  
    const response = await axios(config)
    return response.data.Message;
  } catch (error) {
    handleErrorResponse(error);
    if (error.response.status === 400) {
      toast.error(error.response.data.Message);
      return error.response;
    } else {
      toast.error(error.response.data.Message);
    }
  }    
};